import React from "react";

const DribPossession = ({
  width = 17,
  height = 19,
  stroke = "#2F6AF5",
  strokeWidth = 1.65,
  strokeLinecap = "round",
  strokeLinejoin = "round",
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#1ABFBA" fill-opacity="0.1" />
      <path
        d="M23.6269 26.61L15.8687 25.707C15.4093 25.6582 15.1148 25.4146 14.9852 24.9762C14.8556 24.5377 14.9613 24.1671 15.3023 23.8643L28.0691 12.4064C28.1274 12.3472 28.1948 12.3033 28.2714 12.2746C28.348 12.245 28.4584 12.2302 28.6029 12.2302C28.8378 12.2302 29.0231 12.3316 29.1588 12.5343C29.2945 12.737 29.2958 12.9501 29.1627 13.1737L24.3042 21.4148L32.112 22.3179C32.5714 22.3666 32.8702 22.6058 33.0085 23.0356C33.1469 23.4654 33.0451 23.8321 32.7032 24.1357L19.9364 35.6197C19.8781 35.678 19.8106 35.7176 19.7341 35.7385C19.6575 35.7594 19.547 35.7698 19.4026 35.7698C19.1677 35.7698 18.9907 35.6689 18.8715 35.4671C18.7523 35.2652 18.751 35.0603 18.8676 34.8524L23.6269 26.61ZM22.0609 31.8522L31.4295 23.5407L22.2005 22.5071L25.9876 16.1048L16.576 24.4424L25.7723 25.5438L22.0609 31.8522Z"
        fill="#1ABFBA"
      />
    </svg>
  );
};

export default DribPossession;
